import { CircleMemberStateProvider } from '@/circle/contexts/CircleMemberStateProvider'
import { SidebarProvider } from '@/layout/contexts/SidebarContext'
import { ApolloProvider } from '@apollo/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import { StoreProvider } from 'easy-peasy'
import React from 'react'
import { I18nextProvider } from 'react-i18next'
import { Route, BrowserRouter as Router, Routes } from 'react-router'
import { createApolloClient } from 'src/apolloClient'
import i18n from 'src/i18n'
import { store } from 'src/store'
import theme from 'src/theme'
import OrgPage from './OrgPage'
import { AuthProvider } from '@/user/contexts/AuthProvider'

const apolloClient = createApolloClient()

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <ApolloProvider client={apolloClient}>
          <AuthProvider>
            <SidebarProvider>
              <StoreProvider store={store}>
                <Router>
                  <CircleMemberStateProvider>
                    <Routes>
                      <Route path="*" element={<OrgPage />} />
                    </Routes>
                  </CircleMemberStateProvider>
                </Router>
              </StoreProvider>
            </SidebarProvider>
          </AuthProvider>
        </ApolloProvider>
      </ChakraProvider>
    </I18nextProvider>
  )
}
